import { render, staticRenderFns } from "./CheckoutShipMethod.vue?vue&type=template&id=54713383"
import script from "./CheckoutShipMethod.vue?vue&type=script&lang=js"
export * from "./CheckoutShipMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports